"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageButtons = getPageButtons;
exports.isButtonDisabled = isButtonDisabled;
function getPageButtons(currentPage, totalPages) {
  let result = [];
  for (let i = 1; i <= totalPages; i++) {
    if (currentPage === i) {
      // handle current
      result.push({
        content: i.toString(),
        isCurrent: true,
        isEllipsis: false
      });
    } else if (
    // handle first and last
    i === 1 || i === totalPages ||
    // all numbers should be visible if less than 6 pages
    totalPages < 7 ||
    // handle 1 before/after current
    i === currentPage - 1 || i === currentPage + 1 ||
    // handle 2 after current if current is first
    currentPage === 1 && i === 3 ||
    // show 2 instead of ellipsis if current is 4
    currentPage === 4 && i === 2 ||
    // handle 4 when total is 5
    i === 4 && totalPages === 5 ||
    // handle 2 after current if current is total - 3
    currentPage === totalPages - 3 && i === currentPage + 2 ||
    // handle 2 before current if current is total - 2 and current >= 6
    currentPage >= 6 && currentPage === totalPages - 2 && i === currentPage - 2 ||
    // handle 2 and 3 before current if current is total -1 and current > 6
    currentPage > 6 && currentPage - i >= 2 && currentPage - i <= 3 && currentPage === totalPages - 1 ||
    // handle 2 to 4 before current if current is total and current > 6
    currentPage > 6 && currentPage - i >= 2 && currentPage - i <= 4 && currentPage === totalPages) {
      result.push({
        content: i.toString(),
        isCurrent: false,
        isEllipsis: false
      });
    } else if (!result[result.length - 1].isEllipsis) {
      result.push({
        content: "&hellip;",
        isCurrent: false,
        isEllipsis: true
      });
    }
  }
  return result;
}
function isButtonDisabled(isPrev, currentPage, totalPages) {
  if (isPrev && currentPage === 1 || !isPrev && currentPage === totalPages) {
    return true;
  }
  return false;
}